module.exports = __webpack_public_path__ + "static/img/fun1.06876393.png";